<script>
	import Fuzzy from "svelte-fuzzy";
	import sticky from '../sticky.js'
	export let data;
	export let selectBlock;

	export let stickToTop = true;

	let maxResults = 5;


	let isStuck = false;

	function handleStuck(e) {
		isStuck = e.detail.isStuck;
	}
  
	let query = '';
  
  let options = { 
    keys: ["id", "question", "answer"],
		includeMatches: true,
		minMatchCharLength: 3,
		findAllMatches: true,
		threshold: 0.38,
		distance: 200,
		shouldSort: true,
		ignoreLocation: false
	 };

  let formatted = [];

	let active = false;

	function focusInput() {
		active = true;

    if (!isStuck) {
      if (this.getBoundingClientRect().top > window.innerHeight / 2) {
        this.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
		}
	}

function processSelection(item) {
    const id = item[0][0]['text'];
    const q = item[1];
    const a = item[2];
		active = false;
		selectBlock(id, true, q, a);
	}

	function handleEscape({key}) {
		if (key === 'Escape' || !key) {
			active = false;
    } 
  }

	function handleOtherKeys({key}) {
    if (key !== 'Escape' && !active) {
      active = true;
    }
  }
  $: console.log(formatted);

  </script>

{#if !stickToTop}
<slot />
{/if}

<svelte:window on:keyup={handleEscape} />
<div 	class="search" 
		class:active={active}
		class:results={active && query}
		class:sticky={isStuck}
		data-position={stickToTop ? 'top' : 'bottom'}
        use:sticky={{ stickToTop }}
        on:stuck={handleStuck}>
	

	<div class="input-wrapper">
		<svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="15" cy="10.5" r="10" stroke="#3B3B3B"/>
			<path d="M7.5 17L1 23.5" stroke="#3B3B3B"/>
		</svg>

    <input bind:value={query} on:click={focusInput} on:keydown={handleOtherKeys} placeholder="z. B. Meinung, abonnieren"/>
	</div>

	<Fuzzy {query} {data} {options} bind:formatted />
	<div class="search-results" class:active={active}>
		
		{#each formatted.slice(0, maxResults) as item}
			<div class="item">
			{#each item as line}
        <div on:click={processSelection(item)}>
          {#each line as { key, matches, text }}
					{#if key !== 'id'}
							{#if matches}
								<mark>{text}</mark>
							{:else}
								{text}
							{/if}
					{/if}	
					{/each}
				</div>
			{/each}
			</div>
		{/each}
		{#if query !== '' && formatted.length === 0}
      <div class="noresults">
        Keine Ergebnisse
			</div>
		{/if}
	</div>
</div>

{#if stickToTop}
<slot />
{/if}

<div id="overlay" on:click={handleEscape}></div>


<style lang="scss">
	@import "../main.scss";
	.search {
		position: sticky;
		z-index: 2;
		border: 1px solid #ABABAB;
		background-color: #fff;
		border-radius: 5px;
    max-width: 620px;	
    width: calc(100% - 20px);
		margin: 0 auto;
		box-sizing: border-box;
    top: 50px;


    &.results {
      border-radius: 5px 5px 0 0;

      .input-wrapper {
        border-radius: 5px 5px 0 0;
      }
    }

    @media (max-width: 640px) {
      top: 40px;
    }

		&.active {
			filter: drop-shadow(0px 0px 25px rgba(0, 0, 0, 0.15));

			 + #overlay {
				display: block;
			 }
		}

		&.sticky {
			left: 0;
			width: 100%;
			max-width: none;
			border: none;
			padding: 10px 10px 10px 10px;
			z-index: 1001;
			// background-color: #dbc5c5;
			box-shadow: 0px 10px 8px rgba(0, 0, 0, 0.1);

			@media (max-width: 960px) {
				top: 40px;
			}

			.input-wrapper {
				max-width: 620px;
				margin: 0 auto;
				border: 1px solid #ABABAB;
				border-radius: 5px;
        padding: 4px 3px;
			}
		}
  }

  :global(.tslr--app) .search {
    top: 0 !important;
  }

	.input-wrapper {
		display: flex;
		align-items: center;
		padding: 10px;
		box-sizing: border-box;
    transition: padding 0.4s ease;

		svg {
			width: 24px;
			margin-right: 6px;
		}
		
		input {

			display: block;
			width: calc(100% - 30px);
			border: none;
			font-family: "Franklin Gothic FS";

			&:active, &:focus {
				border: none;
				outline: none;
			}
		}
  }

	.search-results {
		display: none;
		margin: 0 auto;
		padding: 0;
    overflow-y: auto;
    position: absolute;
    z-index: 4;
    background: #fff;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 620px;
    top: 47px;
    box-shadow: 0 30px 18px rgba(0, 0, 0, 0.2);
    border-radius: 0 0 6px 6px;
    user-select: none;

    @media (max-width: 620px) {
      left: 0;
      transform: none;
    }

    @media (max-width: 480px) {
      top: 46px;
    }

		&.active {
			display: block;
		}

		.item {
			cursor: pointer;
      padding: 10px 25px;

      @media (max-width: 480px) {
        padding: 10px 10px;
      }

      &:first-child {
        padding-top: 20px;

        @media (max-width: 620px) {
          margin-top: 10px;
        }
      }

      &:last-child {
        padding-bottom: 20px;

        @media (max-width: 620px) {
          margin-bottom: 10px;
        }
      }

			&:hover {
				background-color: #D9D9D9;
			}

			mark {
				font-weight: 600;
				background: none;
			}

      div:nth-child(1) {
        display: none;
      }

			div:nth-child(2) {
				font-weight: 500;
  			font-size: 20px;
				line-height: 24px;
        font-family: $ff-sans;

        @media (max-width: 480px) {
          font-size: 18px;
          line-height: 22px;
        }
			}

			div:nth-child(3) {
				font-weight: 400;
				font-size: 16px;
				line-height: 24px;
				font-family: $ff-sans;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
        overflow: hidden;

        @media (max-width: 480px) {
          font-size: 16px;
          line-height: 20px;
        }
			}

			&:nth-child(n+10) {
				display: none;
			}
		}

		.noresults {
			//background-color: #F2F0EE;
			padding: 20px 25px;
			color: #A7A7A7;
			font-weight: 500;
      font-size: 14px;
      font-family: $ff-sans;
      line-height: 21px;

      @media (max-width: 480px) {
        padding: 20px 10px;
      }
		}
  }


  .sticky .search-results {
    top: 56px;

    @media (max-width: 480px) {
      top: 54px;
    }
  }



	#overlay {
		position: fixed;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		background-color: #D9D9D9;
		opacity: .6;
		z-index: 1;
		display: none;
  }

</style>
